import type { User } from 'core/services/auth/auth.models';
import { captureError } from 'infra/monitoring/monitoring.utils';
import { deburrLowerCase } from './strings';

export const validateUserAgainstAccessToken = (userFromMeEndpoint: User) => {
  const accessTokenData = window.atob(localStorage.getItem('access_token')?.split('.')[1] ?? '');
  const { sub: idFromAccessToken, user_name: userNameFromAccessToken } = JSON.parse(
    accessTokenData.length ? accessTokenData : '{}'
  ) as Partial<Record<'sub' | 'user_name', string>>;

  const { id, login } = userFromMeEndpoint;

  if (idFromAccessToken?.toLowerCase() !== id.toLowerCase() || deburrLowerCase(userNameFromAccessToken ?? '') !== deburrLowerCase(login)) {
    captureError(new Error('STRANGE BEHAVIOR: User from /me does not match the user from the access token'), {
      domain: 'Auth',
      errorType: 'ValidationError',
      idFromAccessToken,
      userNameFromAccessToken,
      idFromMeEndpoint: id,
      loginFromMeEndpoint: login
    });
  }
};
